export const MAKELAARS_URL_EXTENSION = "brokers";
export const MAKELAARS_URL_LOCAL = "https://develop-docker.emsclaimsengine.com/external-api/brokers";

export const HERSTEL_PARTNERS_URL_EXTENSION = "repairers";
export const HERSTEL_PARTNERS_URL_LOCAL = "https://develop-docker.emsclaimsengine.com/external-api/repairers";
